import React from "react";
import { motion } from "framer-motion";

/**
 * LiquidGlassBg - Animated background blobs for depth
 */
export function LiquidGlassBg({ opacity = "opacity-10" }) {
  return (
    <div className="blob-container pointer-events-none">
      <div className={`blob w-[500px] h-[500px] -top-20 -left-20 ${opacity}`} />
      <div
        className={`blob w-[400px] h-[400px] top-1/2 -right-20 ${opacity}`}
        style={{ animationDelay: "2s" }}
      />
      <div
        className={`blob w-[300px] h-[300px] bottom-0 left-1/3 ${opacity}`}
        style={{ animationDelay: "4s" }}
      />
    </div>
  );
}

/**
 * MacbookFrame - High-fidelity MacBook Pro mockup
 */
export function MacbookFrame({ children, className = "" }) {
  return (
    <div className={`macbook-frame group ${className}`}>
      <div className="macbook-screen">
        {/* Webcam Area */}
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[120px] h-[25px] bg-[#0A0A0B] rounded-b-2xl z-20 flex items-center justify-center border-x border-b border-white/5">
          <div className="w-1.5 h-1.5 rounded-full bg-[#111] shadow-inner" />
        </div>
        <div className="relative h-full w-full bg-white overflow-hidden shadow-inner">
          {children}
          {/* Subtle screen overlay for realism */}
          <div className="absolute inset-0 pointer-events-none bg-gradient-to-tr from-white/5 via-transparent to-white/10 opacity-30" />
        </div>
      </div>
      <div className="macbook-base" />
    </div>
  );
}

/**
 * IphoneFrame - High-fidelity iPhone 15 Pro mockup with Dynamic Island
 */
export function IphoneFrame({ children, className = "" }) {
  return (
    <div className={`iphone-frame group ${className}`}>
      <div className="iphone-dynamic-island">
        <div className="w-12 h-1 bg-white/5 rounded-full" />
        <div className="iphone-island-dot" />
      </div>
      <div className="iphone-screen">
        <div className="relative h-full w-full bg-white overflow-hidden">
          {children}
        </div>
      </div>
    </div>
  );
}
